import { ConsultantImport_RowFragment } from "@graphql";

/**
 * typegen doesn't want to work correctly here with unions
 * not sure why
 * had to type this manually:
 */

export interface ConsultantImportResultInvalid {
  __typename: "SaveConsultantsResultInvalid";
  Rows: ConsultantImport_RowFragment[];
}

export interface ConsultantImportResultOK {
  __typename: "SaveConsultantsResultOK";
  Msg: string;
  Consultants: Array<{ _id: string; Name: string }>;
}

export type ConsultantImportResult =
  | ConsultantImportResultInvalid
  | ConsultantImportResultOK;

export function isInvalid(
  arg: ConsultantImportResult
): arg is ConsultantImportResultInvalid {
  return arg.__typename === "SaveConsultantsResultInvalid";
}

export function isOK(arg: ConsultantImportResult): arg is ConsultantImportResultOK {
  return arg.__typename === "SaveConsultantsResultOK";
}
